import { UnitsSwitchProps } from '@slal/ui/react-hook-form/fields';
import { StyledSwitch } from './styles';

export const Switch = ({ options, fieldName, ...otherProps }: UnitsSwitchProps) => {
    return <StyledSwitch options={options} fieldName={fieldName} {...otherProps} />;
};
